import React from "react";

import type { PolymorphicBoxProps } from "~/components/polymorphic-box";
import { cx } from "~/tools/class-variance";

const DEFAULT_ELEMENT = React.Fragment;

export interface SkeletonBoundaryProps<TValue> {
	when: TValue;
	children: React.ReactNode;
}

export const SkeletonBoundary: <TValue, TElement extends React.ElementType = typeof DEFAULT_ELEMENT>(
	props: PolymorphicBoxProps<TElement, SkeletonBoundaryProps<TValue>>,
) => React.ReactNode = React.forwardRef(
	(
		{
			el: Element = DEFAULT_ELEMENT,
			when,
			children,
			...props
		}: PolymorphicBoxProps<React.ElementType, SkeletonBoundaryProps<unknown>>,
		ref,
	) => {
		if (Element === React.Fragment) {
			return <>{children}</>;
		}

		const skeletonProps =
			when == null
				? {
						className: cx(props.className as string, "skeleton-boundary"),
					}
				: {};

		return (
			<Element ref={ref} {...props} {...skeletonProps}>
				{children}
			</Element>
		);
	},
);
